import { U21Chip } from 'app/shared/u21-ui/components';
import { SarStatusTypes } from 'app/modules/fincenSAR/models';

type OwnProps = {
  status: SarStatusTypes;
};

export const GoAMLStatusLabel = ({ status }: OwnProps) => {
  if (status === 'ARCHIVED') return <U21Chip>Archived</U21Chip>;
  if (status === 'PREFILING_VALIDATION_PENDING')
    return <U21Chip>Pending validation</U21Chip>;
  if (status === 'PREFILING_VALIDATION_SUCCESS')
    return <U21Chip color="success">Validation success</U21Chip>;
  return <U21Chip color="error">Validation failed</U21Chip>;
};
